import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { NavLink, Outlet } from 'react-router-dom';
import Navigation from './layout-components/Navigation';
import Sidebar from './layout-components/Sidebar';
import { useGetCurrentUserQuery } from '../store/user/userApi';
import { useTheme } from '../utils/theme-context';
import { classNames } from '../utils/classNames';

const Layout = () => {
    const { theme } = useTheme();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { data: userInfo } = useGetCurrentUserQuery();

    return (
        <div className='bg-white dark:bg-bgColor-darkMode flex flex-col min-h-screen'>
            <Transition.Root show={sidebarOpen} as={Fragment}>
                <Dialog
                    as='div'
                    className='relative z-40 md:hidden'
                    onClose={setSidebarOpen}
                >
                    <Transition.Child
                        as={Fragment}
                        enter='transition-opacity ease-linear duration-300'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='transition-opacity ease-linear duration-300'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='fixed inset-0 bg-gray-600 bg-opacity-75' />
                    </Transition.Child>

                    <div className='fixed inset-0 flex z-40'>
                        <Transition.Child
                            as={Fragment}
                            enter='transition ease-in-out duration-300 transform'
                            enterFrom='-translate-x-full'
                            enterTo='translate-x-0'
                            leave='transition ease-in-out duration-300 transform'
                            leaveFrom='translate-x-0'
                            leaveTo='-translate-x-full'
                        >
                            <Dialog.Panel className='relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white dark:bg-bgColor-darkMode'>
                                <Transition.Child
                                    as={Fragment}
                                    enter='ease-in-out duration-300'
                                    enterFrom='opacity-0'
                                    enterTo='opacity-100'
                                    leave='ease-in-out duration-300'
                                    leaveFrom='opacity-100'
                                    leaveTo='opacity-0'
                                >
                                    <div className='absolute top-0 right-0 -mr-12 pt-2'>
                                        <button
                                            type='button'
                                            className='ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'
                                            onClick={() => setSidebarOpen(false)}
                                        >
                                            <span className='sr-only'>Close sidebar</span>
                                            <img src='/assets/shared/close-grey.svg' alt='close' />
                                            <span className='h-6 w-6 text-white' aria-hidden='true' />
                                        </button>
                                    </div>
                                </Transition.Child>
                                <div className='flex-shrink-0 flex items-center px-4 mb-2 md:mb-10 bg-white p-1'>
                                    <NavLink to='/'>
                                        <img className='max-h-8 w-auto' src='/images/logo.svg' alt='logo' />
                                    </NavLink>
                                </div>
                                <div className='mt-5 flex-1 h-0 overflow-y-auto'>
                                    <nav className='px-4 md:px-2 space-y-1'>
                                        <Navigation closeSidebar={() => setSidebarOpen(false)} />
                                    </nav>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                        <div className='flex-shrink-0 w-14' aria-hidden='true'></div>
                    </div>
                </Dialog>
            </Transition.Root>
            <Sidebar />

            <div className='flex flex-col flex-1 md:pl-64'>
                <header className='sticky top-0 z-20 flex-shrink-0 flex bg-white dark:bg-bgColor-darkMode px-2 h-20'>
                    <button
                        type='button'
                        className='px-4 text-gray-500 md:hidden'
                        onClick={() => setSidebarOpen(true)}
                    >
                        <span className='sr-only'>Open sidebar</span>
                        <img src='/svg/icons/list.svg' width={25} alt='' />
                    </button>
                    <div className='flex-1 pr-4 flex justify-between'>
                        <div className='flex-1 flex flex-row justify-between'>
                            {/* <Profile /> */}
                            <div className=' bg-white dark:bg-bgColor-darkMode flex items-center text-sm rounded-full focus:outline-none'>
                                <div className='md:ml-5 flex mr-2'>
                                    <NavLink to='/'>
                                        <img
                                            className={classNames('w-10 h-10 md:w-14 md:h-14 object-contain', userInfo?.data.logoUrl ? 'rounded-full' : '')}
											src={'/images/profile.svg'}
                                            alt='main photo'
                                        />
                                    </NavLink>
                                    <div className='text-left ml-1 md:ml-4 mr-3'>
                                        <div className='text-base font-medium text-black mt-2 md:mt-4 dark:text-primary-darkMode'>{(userInfo?.data.name)}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='flex md:ml-0 my-auto'>
                                <NavLink to='/'>
                                    <img src={theme === 'dark' ? '/assets/chat/hotelworld-logo-white.svg' : '/assets/chat/hotelworld-logo.svg'} className='object-contain h-[30px]' />
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </header>
                <main className='flex-1 px-5 py-4 w-full'>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;
